import { $$ } from 'utils/dom';
import LoadMore from 'modules/load-more';

const awardsTeasers = $$('.teaser-awards[data-ajax]');
awardsTeasers.length &&
  awardsTeasers.forEach(teaser => {
    teaser &&
      new LoadMore({
        container: teaser,
      }).init();
  });
